module.exports = __webpack_public_path__ + "static/media/no-image.5a021ab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/no-image.png
// module id = 168
// module chunks = 1